<template>
  <div class="card-cont">
    <div class="card-bg-img">
      <img :src="cardBgImg" />
    </div>
    <div class="BS-slide view-slide view-slide-card card-comp">
      <div class="slide-text-part">

          <img v-if="logo" :src="cardLogo" v-on:click="select($event)" />
          <h3 class="card-name card-name-rounded" v-if="!logo" v-on:click="select($event)">
            {{ name }}
            <span class="minimized-indicator minimized-indicator-right">
              <div class="tooltip">
                <label class="opened">Opened</label>
                <label class="closed">Closed</label>
              </div>
          </span>
          </h3>
        
        <div class="clearfix"></div>
        <p>
          {{ title }}<br v-if="title" />
          <span v-html="description"></span>
        </p>
        <div class="text-center">
          <button v-on:click="select($event)">
            OPEN APP <img :src="arrowImg" />
          </button>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "appCardRoundedComponent",
  props: ["name", "title", "description", "bgImg", "logo"],
  computed: {
    cardLogo: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.logo}`;
    },
    cardBgImg: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.bgImg}`;
    },
    arrowImg: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.$store.state.style["--arrow_image"]}`;
    },
  },
};
</script>

<style>
.card-cont {
  position: relative;
  z-index: 0;
}
.view-slide-card {
 width: 100%;
    height: 445px;
    float: left;
    color: #000;
    background: var(--card_bg) !important;
    border: var(--card_border);
    -webkit-box-shadow: var(--card_shadow);
    box-shadow: var(--card_shadow);
    z-index: 1;
    margin-top: 2rem;
    margin-bottom: 3rem;
}
.view-slide-card .slide-text-part {
  margin-top: 9rem;
  height: 310px;
  text-align: center;
}
.card-bg-img {
  position: absolute;
  z-index: 2;
  margin: 0% 22.5%;
 
}

.card-bg-img img{
 width: 170px;
    height: 170px;
}
.card-name {
  letter-spacing: 0px !important;
  font-weight: normal;
  
}
.card-name-rounded{
  float: none !important;
}
.card-name span {
  font-weight: bold;
}
.card-comp {
  border-radius: 15px;
}

.card-bg-img img {
  border-radius: 50%;
  margin: auto;
  display: inherit;
}

.minimized-indicator-right {
  float: none !important;
  display: inline-block  !important;
  position: absolute  !important;
}
</style>
